import React from "react";
// import "./AboutUs.css";
import sampleImage from "../media3/aboutus/img1.png";
import icon1 from "../media3/aboutus/icon1.svg";
import icon2 from "../media3/aboutus/icon2.svg";
import ellipse from "../media3/aboutus/ellipse.png"
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
     const navigate = useNavigate();
  return (
    <section className="about-section" id="about-us-section">
      <div className="about-left">
        <p className="about-label">About Us</p>
        <h1 className="about-title">
          SkinForge : Redefining How Players Own Skins
        </h1>
        <p className="about-desc">
         SkinForge is your ultimate destination to explore, discover, and own the finest gaming skins.
          Instant purchases, zero hassle — just pure skin mastery at your fingertips.
        </p>

     <div className="about-points">
      <div className="point">
     <div className="icon-wrapper">
      <img src={ellipse} alt="ellipse" className="ellipse-img" />
      <img src={icon1} alt="icon1" className="icon-img" />
      </div>
     <div>
      <h4>Built for Gamers</h4>
      <p>
        Designed with players in mind, SkinForge brings you a seamless way to power up your inventory.
      </p>
     </div>
     </div>

     <div className="point">
    <div className="icon-wrapper">
      <img src={ellipse} alt="ellipse" className="ellipse-img" />
      <img src={icon2} alt="icon2" className="icon-img" />
    </div>
    <div>
      <h4>Trusted Marketplace</h4>
      <p>
        With real-time prices and curated collections, every purchase is secure, transparent, and instant.
      </p>
    </div>
     </div>
    </div>


        {/* <button className="about-btn"  onClick={handleExploreClick}>Click Here</button> */}
     <button
            className="about-btn"
          onClick={() => {
            navigate("/categories");
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
          }}
        >
          Click Here
        </button>
      </div>

      <div className="about-right">
        <div className="about-image">
          <img src={sampleImage} alt="About Illustration" />
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
